import React from 'react';
import { Box, Container, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';

const services = [
	{
		title: 'Search Engine Optimization',
		description:
			"Improve your website's visibility in search results and drive organic traffic.",
		path: '/services/seo',
		image: '/assets/services/seo.jpg',
	},
	{
		title: 'Social Media Marketing',
		description:
			'Engage your audience and build brand awareness through strategic social media management.',
		path: '/services/social-media-marketing',
		image: '/assets/services/smm-1.jpg',
	},
	{
		title: 'Google Ads',
		description:
			'Reach your target audience with precision through paid advertising campaigns.',
		path: '/services/google-ads',
		image: '/assets/services/ga-2.jpg',
	},
	{
		title: 'Website Designing',
		description:
			'Create beautiful, responsive websites that convert visitors into customers.',
		path: '/services/website-designing',
		image: '/assets/services/wd-1.jpg',
	},
	{
		title: 'App Development',
		description:
			'Build fast, secure Android, iOS, and cross-platform mobile apps for your business.',
		path: '/services/app-development',
		image: '/assets/services/ga-1.jpg',
	},
	{
		title: 'Influencer Marketing',
		description:
			'Leverage the power of social media influencers to promote your brand.',
		path: '/services/influencer-marketing',
		image: '/assets/services/im-1.jpg',
	},
	{
		title: 'WhatsApp Marketing',
		description:
			'Connect with customers directly through WhatsApp business messaging.',
		path: '/services/whatsapp-marketing',
		image: '/assets/services/wm-1.png',
	},
	{
		title: 'Online Reputation Management',
		description:
			'Build and maintain a positive online presence for your brand.',
		path: '/services/orm',
		image: '/assets/services/orm-1.jpg',
	},
	{
		title: 'PR Agency',
		description:
			'Manage your public relations and media presence effectively.',
		path: '/services/pr-agency',
		image: '/assets/services/pr-1.jpg',
	},
	{
		title: 'Email Marketing',
		description:
			'Create engaging email campaigns that drive conversions.',
		path: '/services/email-marketing',
		image: '/assets/services/em-1.jpg',
	},
];

export default function ServicesPage() {
	const navigate = useNavigate();

	return (
		<Box
			sx={{
				pt: { xs: 8, sm: 10 },
				pb: { xs: 6, sm: 8 },
				background: 'linear-gradient(135deg, #FD8112, rgb(11, 145, 202))',
				minHeight: '100vh',
			}}
		>
			
<Box
  sx={{
    position: 'fixed',
    top: { xs: 50, sm: 70 },
    left: { xs: 12, sm: 24 },
    zIndex: 1200,
    bgcolor: 'linear-gradient(135deg,rgb(241, 176, 119), rgb(11, 145, 202))',
    borderRadius: '50%',
    boxShadow:5,
    width: { xs: 40, sm: 48 },
    height: { xs: 40, sm: 48 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <IconButton
    onClick={() => navigate(-1)}
    size="medium"
    sx={{
      color: '#1877f2',
      p: 0.5
    }}
  >
    <ArrowBackIosNewIcon fontSize="small" />
  </IconButton>
</Box>
			<Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
				<Typography
					variant="h3"
					sx={{
						textAlign: 'center',
						mb: { xs: 4, sm: 6 },
						color: 'white',
						fontWeight: 'bold',
						fontFamily: 'Nunito, serif',
						fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
					}}
				>
					Our Services
				</Typography>

				<Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
					{services.map((service, index) => (
						<Grid item xs={12} sm={6} md={4} key={index}>
							<Card
								sx={{
									height: '100%',
									display: 'flex',
									flexDirection: 'column',
									transition:
										'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
									'&:hover': {
										transform: { sm: 'translateY(-8px)' },
										boxShadow: 3,
									},
									borderRadius: { xs: 2, sm: 3 },
									overflow: 'hidden',
								}}
							>
								<Box
									sx={{
										bgcolor: 'rgb(145, 175, 194)',
										p: { xs: 2, sm: 3 },
										textAlign: 'center',
										height: { xs: '200px', sm: '250px' },
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										overflow: 'hidden',
									}}
								>
									<Box
										component="img"
										src={service.image}
										alt={service.title}
										sx={{
											width: '200%',
											height: '120%',
											objectFit: 'cover',
											transition: 'transform 0.3s ease-in-out',
											'&:hover': {
												transform: 'scale(1.05)',
											},
										}}
									/>
								</Box>
								<CardContent
									sx={{
										flexGrow: 1,
										p: { xs: 2.5, sm: 3 },
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<Typography
										variant="h5"
										component="h2"
										sx={{
											mb: { xs: 1.5, sm: 2 },
											fontWeight: 'bold',
											fontFamily: 'Nunito, serif',
											color: 'primary.main',
											fontSize: { xs: '1.25rem', sm: '1.5rem' },
											lineHeight: 1.3,
											textAlign: { xs: 'center', sm: 'left' },
										}}
									>
										{service.title}
									</Typography>
									<Typography
										variant="body1"
										sx={{
											color: 'text.secondary',
											fontFamily: 'Nunito, serif',
											fontSize: { xs: '0.875rem', sm: '1rem' },
											lineHeight: 1.6,
											mb: { xs: 2, sm: 3 },
											textAlign: { xs: 'center', sm: 'left' },
										}}
									>
										{service.description}
									</Typography>
									<Box
										sx={{
											mt: 'auto',
											textAlign: { xs: 'center', sm: 'left' },
										}}
									>
										<Button
											variant="contained"
											onClick={() => navigate(service.path)}
											sx={{
												bgcolor: 'rgb(31, 161, 242)',
												'&:hover': { bgcolor: 'rgb(17, 55, 79)' },
												fontFamily: 'Nunito, serif',
												px: { xs: 3, sm: 4 },
												py: { xs: 1.5, sm: 2 },
												fontSize: { xs: '0.875rem', sm: '1rem' },
												width: { xs: '100%', sm: 'auto' },
											}}
										>
											Learn More
										</Button>
									</Box>
								</CardContent>
							</Card>
						</Grid>
					))}
				</Grid>
			</Container>
		</Box>
	);
}